import script from "./SubscriptionPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPlans.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPlans.vue?vue&type=style&index=0&id=b88213f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b88213f0"]])

export default __exports__